// GENERATED by scripts/build-icons.mjs from icons/search.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Search = createIcon('search', [
  ['path', { d: "m21 21-4.34-4.34" }],
  ['circle', { cx: "11", cy: "11", r: "8" }],
])
